import { registerPlugin } from '@capacitor/core';
/**
 * 네이티브 전용 — web 구현을 두지 않는다. 웹에서 호출하면 Capacitor 가
 * "not implemented on web" 으로 거절하며, 스캔 화면 자체가 네이티브 전용이라
 * 정상 경로에서는 도달하지 않는다.
 */
const CardEngine = registerPlugin('CardEngine');
export * from './definitions';
export { CardEngine };
//# sourceMappingURL=index.js.map